module.exports = __webpack_public_path__ + "img/fuwu_normal.3be794a6.png";